import { Dayjs } from "dayjs";
import { useMemo } from "react";
import { useEventFilters } from "components/manualReview/contexts/EventFilterContext";
import { RAILCARS_FILTER } from "components/manualReview/filters/eventFilters";
import { railcarMovementsToTicks } from "components/manualReview/DayTimeline/timelineTick";
import {
  ReviewTimelineTick,
  useGetRailcarMovementsQuery,
} from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";

const NO_TICKS: ReviewTimelineTick[] = [];

export const useRailcarTimelineTicks = (
  dayStart: Dayjs,
  dayEnd: Dayjs
): ReviewTimelineTick[] => {
  const tenantName = useTenant();
  const { filters } = useEventFilters();
  const railcarsEnabled = useIsBehindFeatureFlag("rail_car_movements");
  const active = railcarsEnabled && filters.includes(RAILCARS_FILTER);

  const { data } = useGetRailcarMovementsQuery(
    {
      tenantName,
      startTime: dayStart.utc().toISOString(),
      endTime: dayEnd.utc().toISOString(),
    },
    { skip: !active }
  );

  return useMemo(
    () => (data ? railcarMovementsToTicks(data.railcar_movements) : NO_TICKS),
    [data]
  );
};
